import React from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Alert } from "reactstrap";
import { msgActions } from "../../../../../redux/actions";

function MsgModal({ msg, translate, dispatch }) {
  const toggleMsgBox = () => {
    dispatch(msgActions.clear());
  };

  return (
    <Modal isOpen={!!msg.type} toggle={toggleMsgBox} zIndex={"99999999999"}>
      <ModalHeader toggle={toggleMsgBox}>{msg.header}</ModalHeader>
      <ModalBody>
        <Alert color={msg.type}>{msg.message}</Alert>
      </ModalBody>
      <ModalFooter className="text-center">
        <button
          type="button"
          className="switchBtn"
          style={{ width: "100px" }}
          onClick={toggleMsgBox}
        >
          {translate("OK")}
        </button>
      </ModalFooter>
    </Modal>
  );
}

function mapStateToProps(state) {
  const { locale, msg } = state;
  return {
    msg,
    translate: getTranslate(locale),
  };
}

const connectedMsgModal = connect(mapStateToProps)(MsgModal);
export { connectedMsgModal as MsgModal };
